Vue.component('ack-curo-resins-product', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curo-resins-product',
	created() {
		this.selectAvailableVariant();
	},
	mounted() {},
	props: {
		isShowProductMenu: {
			type: Boolean,
			required: false,
			default: true,
		},
		productId: {
			type: String,
			required: true,
		},
		productShopify: {
			type: Object,
			required: true,
		},
		menuItems: {
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		isShowApplicationText: {
			type: Boolean,
			required: false,
			default: true,
		},
		isShowBuyBtn: {
			type: Boolean,
			default: true,
			required: false,
		},
	},
	computed: {
		...Vuex.mapGetters('shop', ['isStoreAvailable']),
		...Vuex.mapGetters('resins', ['activeItem']),
		...Vuex.mapGetters('localization', ['countryCode', 'isUS_CA', 'isIreland']),

		isUSorCA() {
			return this.countryCode.toUpperCase() === 'US' || this.countryCode.toUpperCase() === 'CA';
		},

		isRestrictedProduct() {
			const restrictedProductIds = [
				'6627055435879', // CURO Crown
				'6624780812391', // CURO Model
				'6624785760359', // CURO proDenture
				'6627062448231', // CURO ProSplint Soft
			];

			// Extract the product ID from the full Shopify URL
			const productId = this.productId.split('/').pop();

			return (restrictedProductIds.includes(productId) && this.isUSorCA) || this.isIreland;
		},

		hasChartsOrImages() {
			return (
				this.charts.some((chart) => chart && chart !== '') ||
				this.chartsImages.some((image) => image && image !== '')
			);
		},

		featuresList() {
			let list = [];
			let fNum = parseInt(this.$t(`resins.collection.${this.productId}.bullet_points_count`));
			for (let index = 0; index < fNum; index++) {
				const feature = this.$t(`resins.collection.${this.productId}.bullet_points.${index}`);
				list.push(feature);
			}
			return list;
		},
		kitContainsList() {
			let list = [];
			let fNum = parseInt(this.$t(`resins.collection.${this.productId}.bullet_points_kit_count`));
			for (let index = 0; index < fNum; index++) {
				const feature = this.$t(`resins.collection.${this.productId}.bullet_points_kit.${index}`);
				list.push(feature);
			}
			return list;
		},
		imageSrc() {
			if (this.variants.length < 2) {
				return this.productShopify.images[0];
			} else {
				let selectedVariant = this.variants.find((m) => {
					return m.id == this.selectedVariant.value;
				});
				return selectedVariant.featured_image.src;
			}
		},

		rowClass() {
			const urls = [
				'technical_specifications_url',
				'instructions_for_use_url',
				'safety_data_sheet_url',
			];
			return [1, 2].includes(urls.filter((url) => this.getUrl(url)).length)
				? 'justify-content-center'
				: 'justify-content-start';
		},
		chartsImages() {
			let list = [];
			let fNum = parseInt(
				this.$t(`resins.collection.${this.productId}.mechanical_properties_count`),
			);
			for (let index = 0; index < fNum; index++) {
				const image = this.$t(
					`resins.collection.${this.productId}.mechanical_properties.${index}.image`,
				);
				list.push(image);
			}
			return list;
		},
		chartsLabels() {
			let list = [];
			let fNum = parseInt(
				this.$t(`resins.collection.${this.productId}.mechanical_properties_count`),
			);
			for (let index = 0; index < fNum; index++) {
				const label = this.$t(
					`resins.collection.${this.productId}.mechanical_properties.${index}.label`,
				);
				list.push(label);
			}
			return list;
		},
		charts() {
			let list = [];
			let fNum = parseInt(
				this.$t(`resins.collection.${this.productId}.mechanical_properties_count`),
			);
			for (let index = 0; index < fNum; index++) {
				const chart = {
					color: this.$t(`resins.collection.${this.productId}.color`),
					value: this.$t(
						`resins.collection.${this.productId}.mechanical_properties.${index}.value`,
					),
				};
				list.push(ChartOptions.getChartOptions(chart));
			}
			return list;
		},
		variants() {
			const inventoryLocations = [
				INVENTORY_LOCATION_US,
				INVENTORY_LOCATION_TW,
				INVENTORY_LOCATION_US_2,
				INVENTORY_LOCATION_TW_2,
			];

			return this.productShopify.variants
				.filter((variant) => {
					const locationName = variant.option1;
					const hasLocation = inventoryLocations.includes(locationName);
					if (hasLocation) {
						const isUsCa =
							locationName === INVENTORY_LOCATION_US || locationName === INVENTORY_LOCATION_US_2;
						const isTw =
							locationName === INVENTORY_LOCATION_TW || locationName === INVENTORY_LOCATION_TW_2;
						return this.isUS_CA ? isUsCa : isTw;
					}
					return variant;
				})
				.map((variant) => {
					const locationName = variant.option1;
					const hasLocation = inventoryLocations.includes(locationName);
					const locationPosition = 0;
					const excludeLocation = (_, i) => i !== locationPosition;
					const newName = (name) =>
						hasLocation ? name.split(' / ').filter(excludeLocation).join(' / ') : name;
					return {
						...variant,
						public_title: newName(variant.public_title),
						title: newName(variant.title),
					};
				});
		},
		selectVariantsOptions() {
			let list = [];
			for (let index = 0; index < this.variants.length; index++) {
				const element = this.variants[index];
				let opt = {
					label: element.title,
					value: element.id,
				};
				list.push(opt);
			}
			return list;
		},
		unavailableProduct() {
			const unavailableProductsIds = [
				'6624780812391', // CURO Model Yellow
			];
			// Extract the product ID from the full Shopify URL
			const productId = this.productId.split('/').pop();
			return unavailableProductsIds.includes(productId);
		},
		isSoldOut() {
			if (this.variants.length < 2) {
				return this.productShopify.available === false;
			} else {
				let selectedVariant = this.variants.find((m) => {
					return m.id == this.selectedVariant.value;
				});
				return selectedVariant ? selectedVariant.available === false : true;
			}
		},
	},
	data() {
		return {
			selectedVariant: null,
			quantity: 1,
			iconColor: '#000000',
			showMenu: true,
			showModal: false,
		};
	},
	methods: {
		...Vuex.mapActions('shop', ['buyNow', 'addToCartFromProperties']),
		...Vuex.mapActions('resins', ['menuItemClick']),
		getUrl(key) {
			const url = this.$t('resins.collection.' + this.productId + '.' + key);
			return url !== 'resins.collection.' + this.productId + '.' + key ? url : null;
		},
		getUrls(key) {
			if (typeof this.$t('resins.collection.' + this.productId + '.' + key) === 'string') {
				return false;
			}

			return this.$t('resins.collection.' + this.productId + '.' + key);
		},
		onIncreaseQuantityClick() {
			this.quantity++;
		},
		onDecreaseQuantityClick() {
			if (this.quantity > 1) {
				this.quantity--;
			}
		},
		onBuyNowClick() {
			this.buyNow({
				variantId: `gid://shopify/ProductVariant/${this.selectedVariant.value}`,
				quantity: this.quantity,
			}).then((url) => {
				window.open(url, '_blank');
			});
		},
		onAddToCartClick() {
			if (this.unavailableProduct) {
				console.log('Attempted to add a restricted product to the cart:', this.productId);
				return;
			}
			this.addToCartFromProperties({
				productId: `gid://shopify/Product/${this.productId}`,
				variantId: `gid://shopify/ProductVariant/${this.selectedVariant.value}`,
				quantity: this.quantity,
			});
		},
		selectAvailableVariant() {
			let availableVariant = this.variants.find((variant) => variant.available);
			if (availableVariant) {
				this.selectedVariant = { value: availableVariant.id, label: availableVariant.title };
			} else {
				this.selectedVariant = { value: this.variants[0].id, label: this.variants[0].title };
			}
		},
	},
	beforeDestroy() {},
	watch: {
		productId: {
			handler() {
				this.selectAvailableVariant();
			},
			immediate: true,
		},
	},
});
